/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { assignmentTypeEnum, statusEnum } from '../../../../../utils/dataStatus';
import { FilesSdsPtContext } from '../../../../../context/FilesSdsPtContext';
import tableTypes from '../../../../../utils/filesTableTypes';
import { AttachedFilesPermissions } from '../../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest, DetailRequestMonthly } from '../../../../../utils/globalPropTypes';
import { getFilesDownloadOptions } from '../../../../../services/workReport';

import Accordion from './Accordion/Accordion';
import Table from './Table/Table';
import './FilesDetailServiceRequest.scss';

const FilesDetailServiceRequest = ({
  idStatus,
  details,
  filesPermissions,
  setIsPendingAuthorization,
  seeAttachedFile
}) => {
  const { dataFilesSDS, dataFilesPt, dataInactivesSDS, setIsMonthly } =
    useContext(FilesSdsPtContext);

  const [downloadOptions, setDownloadOptions] = useState([]);

  const disableButtonSDSCancelled =
    details.estadoEnum === statusEnum.cancelada || details.estadoEnum === statusEnum.finalizada;

  useEffect(() => {
    setIsMonthly(details?.tipoAsignacion.id === assignmentTypeEnum.Mensualizada);
  }, [details]);

  // Esta funcion visualiza por primera vez los nuevos archivos adjuntos
  useEffect(() => {
    seeAttachedFile();
    setIsPendingAuthorization(false);
    const getOptions = async () => {
      const options = await getFilesDownloadOptions();

      setDownloadOptions(options.sort((a, b) => a.id - b.id));
    };

    getOptions();
  }, []);

  return (
    <div>
      <Accordion key="archivos-solicitud" title="Archivos de la solicitud">
        <Table
          columnSds
          details={details}
          disableButtonSDSCancelled={disableButtonSDSCancelled}
          disabledButtonDownloadDelete={!dataFilesSDS.length}
          downloadOptions={downloadOptions}
          onlyButtonDeletedFiles={false}
          permissions={filesPermissions.request}
          sds
          type={tableTypes.sds}
        />
      </Accordion>
      {idStatus >= 3 && (
        <Accordion key="archivos-pr" title="Archivos de parte de trabajo">
          <Table
            columnSds={false}
            details={details}
            disableButtonSDSCancelled={disableButtonSDSCancelled}
            disabledButtonDownloadDelete={!dataFilesPt.length}
            downloadOptions={downloadOptions}
            onlyButtonDeletedFiles={false}
            permissions={filesPermissions.workPart}
            sds={false}
            type={tableTypes.pt}
          />
        </Accordion>
      )}
      <Accordion key="archivos-eliminados" title="Archivos eliminados de la solicitud">
        <Table
          columnSds={false}
          details={details}
          disableButtonSDSCancelled={disableButtonSDSCancelled}
          disabledButtonDownloadDelete={!dataInactivesSDS.length}
          downloadOptions={downloadOptions}
          onlyButtonDeletedFiles
          sds={false}
          type={tableTypes.inactiveSDS}
        />
      </Accordion>
      {idStatus >= 3 && (
        <Accordion key="archivos-elminados-pt" title="Archivos eliminados del parte de trabajo">
          <Table
            columnSds={false}
            details={details}
            disableButtonSDSCancelled={disableButtonSDSCancelled}
            disabledButtonDownloadDelete={!dataInactivesSDS.length}
            downloadOptions={downloadOptions}
            onlyButtonDeletedFiles
            sds={false}
            type={tableTypes.inactivePT}
          />
        </Accordion>
      )}
    </div>
  );
};

FilesDetailServiceRequest.propTypes = {
  idStatus: PropTypes.number,
  filesPermissions: AttachedFilesPermissions,
  details: PropTypes.oneOfType([DetailRequest, DetailRequestMonthly]).isRequired,
  seeAttachedFile: PropTypes.func,
  setIsPendingAuthorization: PropTypes.func
};

FilesDetailServiceRequest.defaultProps = {
  filesPermissions: {
    request: {
      delete: true,
      download: true,
      upload: true
    },
    workPart: {
      delete: true,
      download: true,
      upload: true
    }
  },
  idStatus: undefined,
  seeAttachedFile: () => {},
  setIsPendingAuthorization: () => {}
};
export default FilesDetailServiceRequest;
